import { StihlDistributorLogoDTO } from "./stihl-campaign-dto";



export class StihlDistributorDTO {
    IdDistributor: string;
    Status: boolean;
    Guid: string;
    CreationDate: Date;
    Name: string;
    Account: number;
    AccountName2: string;
    Adg1License: boolean;
    Adg2License: boolean;
    AfterSalesService: boolean;
    B2bCodeText: string;
    Battery: boolean;
    BusinessPhone: string;
    BusinessType: number;
    BuyingGroupName: string;
    City: string;
    CleaningService: boolean;
    ClothingSpecialist: boolean;
    ColloquialName: string;
    Country: string;
    CountryCode: number;
    CreditCardPayment: boolean;
    CrmAccountNumber: string;
    CustomerRatingCode: number;
    DataSourceCode: number;
    DealerLocator: boolean;
    DemonstrationSite: boolean;
    District: string;
    EapPartner: boolean;
    EapPartnerText: string;
    Electro: boolean;
    ElectroBattery: boolean;
    Email: string;
    Exclusivity: boolean;
    ExclusivityText: string;
    Fax: string;
    FinancingService: boolean;
    GciService: boolean;
    GoldLevelService: boolean;
    HolidayFrom: string;
    HolidayTo: string;
    HouseNo: string;
    ImowService: boolean;
    ImowServiceText: string;
    IsPremiumDealer: boolean;
    LanguageCode: number;
    Latitude: string;
    Longitude: string;
    Mdg1License: boolean;
    MobilePhone: string;
    Ms500iService: boolean;
    Name1: string;
    Name2: string;
    OnlineReservation: string;
    OnlineSalesCollecting: string;
    OnlineSalesShipping: string;
    ParentAccountId: string;
    ParentName: string;
    PersonalDelivery: boolean;
    Petrol: boolean;
    PregPublish: boolean;
    PrimaryContactId: string;
    ProductTesting: boolean;
    Qmf: string;
    Region: string;
    RegionCode: number;
    RentalBusiness: boolean;
    RentalBusinessText: string;
    ResponsibleAffiliateImporterId: string;
    Sds4Stroke: boolean;
    SdsImow: boolean;
    SdsInjection: boolean;
    SdsLicence: boolean;
    SdsMt: boolean;
    SdsMtronic: boolean;
    SdsStandard: boolean;
    SmartConnector: boolean;
    SocialFb: string;
    SocialInstagram: string;
    SocialTwitter: string;
    SopDealer: string;
    SopWebsite: string;
    StihlConnected: string;
    StihlServiceCommunication: boolean;
    StihlServicePortal: boolean;
    StihlTrainingInUse: boolean;
    Street: string;
    Street1: string;
    Street2: string;
    Taxnumber1: string;
    Ts440Service: boolean;
    VikingPremiumPartner: boolean;
    Vkorg: string;
    Website: string;
    Zip: string;
    StihlDistributorLogos: StihlDistributorLogoDTO[];
}

export class StihlDistributorLogoPostDTO {
    IdDistributor: string;
    IdCampaignMaterialMediaType: number;
    FileLogo: File;
    Description: string;
}

export class StihlDistributorDataDTO {
    IdDistributorData: string;
    IdDistributor: number;
    BillingContact: string;
    Slogan: string;
    FacebookProfile: string;
    InstaProfile: string;
    TwitterProfile: string;
    LinkedinProfile: string;
    YoutubeProfile: string;
    BankingEntity: string;
    AccountHolder: string;
    Iban: string;
    BicSwift: string;
}

export class StihlDistributorBillingDTO {
    IdDistributorBilling: string | null;
    IdDistributor: number | null;
    BillingType: string | null;
    Tradename: string | null;
    Cif: string | null;
    PrincipalContact: string | null;
    Address: string | null;
    Phone: string | null;
    Mail: string | null;
}


export class StihlDistributorMaterialSendingDTO {
    IdDistributorMaterialSending: string;
    IdDistributor: number;
    Addressee: string;
    Contact: string;
    Address: string;
    Phone: string;
    Mail: string;
    Comments: string;
    AddressStreet: string;
    AddressNumber: string;
    AddressZip: string;
    AddressCity: string;
    AddressRegion: string;
    CompleteAddress: string;
   
}